<template>
    <div>
        <el-carousel
            :interval="5000"
            arrow="hover"
            :height="height"
            indicator-position="none"
        >
            <el-carousel-item v-for="item in imgList" :key="item">
                <img :src="item" alt="bannner图" />
            </el-carousel-item>
        </el-carousel>
        <div class="company-intro">
            <div class="container">
                <div class="i_mbt">
                    <b>走进锦威</b>
                    <div class="line">&nbsp;</div>
                    <div class="des">高科技智慧能效服务商</div>
                </div>
                <intro></intro>
            </div>
        </div>
        <div class="product-system">
            <div class="container">
                <div class="i_mbt">
                    <b class="white-color">三大产品体系</b>
                    <div class="line">&nbsp;</div>
                    <div class="des white-color">
                        禀行科技创造节能未来，立足智慧能效管理市场
                    </div>
                </div>
                <div class="i_ma clearfix">
                    <div class="i_mam i_mal">
                        <div class="tu" @click="jumpProductDetail('zdhxt')">
                            <a href="#">
                                <img
                                    src="../../../../assets/img/mainPage/icon_zd.png"
                                    alt=""
                                />
                                <p>自动化系统</p>
                                <p><span>AUTOMATION SYSTEM</span></p>
                                <div class="line">&nbsp;</div>
                                <i>&nbsp;</i>
                            </a>
                        </div>
                        <div class="wen">
                            <div class="i_about">
                                <img
                                    src="../../../../assets/img/mainPage/s1.jpg"
                                    alt=""
                                />
                                <div class="des">
                                    <p>
                                        暖通和动力系统自动控制；工艺流程自动化系统；TIA全集成自动化系统。冷冻站的模糊控制系统和P3实验室控制系统已申请国家专利。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="i_mam i_mac">
                        <div class="tu" @click="jumpProductDetail('szhxt')">
                            <a href="#">
                                <img
                                    src="../../../../assets/img/mainPage/icon_sz.png"
                                    alt=""
                                />
                                <p>数字化系统</p>
                                <p><span>DIGITAL SYSTEM</span></p>
                                <div class="line">&nbsp;</div>
                                <i>&nbsp;</i>
                            </a>
                        </div>
                        <div class="wen">
                            <div class="i_about">
                                <div class="des digital-des">
                                    <p class="first-p">
                                        将自动化、智能化、BIM技术、信息化技术融合产生了数字化工厂、数字化医院、数字化园区。
                                    </p>
                                    <p>
                                        数字化系统从自动化底层的生产管控、质量控制<br />、设备控制、能耗和物料监测到顶层的设备级、系统级和产业级制造、产品全生命周期、设备全生命周期仿真及分析，并将结果反馈回系统，降低生产的不确定性因素，推动了企业提质增效降本。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="i_mam i_mar">
                        <div class="tu" @click="jumpProductDetail('nyglxt')">
                            <a href="#">
                                <img
                                    src="../../../../assets/img/mainPage/icon_ny.png"
                                    alt=""
                                />
                                <p>能源管理系统</p>
                                <p><span>ENERGY MANAGEMENT SYSTEM</span></p>
                                <div class="line">&nbsp;</div>
                                <i>&nbsp;</i>
                            </a>
                        </div>
                        <div class="wen">
                            <div class="i_about">
                                <img
                                    src="../../../../assets/img/mainPage/s3.jpg"
                                    alt=""
                                />
                                <div class="des">
                                    <p>
                                        能源管理平台建立在底层设备控制和能量计量的基础上，为建筑能源管理和节能策略提供平台。
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="case-show">
            <div class="container">
                <div class="i_mbt">
                    <b>案例展示</b>
                    <div class="line">&nbsp;</div>
                    <div class="des">立足智慧能效管理领域，树行业标杆</div>
                </div>
                <company-case></company-case>
            </div>
        </div>
        <div class="news-center">
            <div class="container">
                <div class="i_mbt">
                    <b>新闻中心</b>
                    <div class="line">&nbsp;</div>
                    <div class="des">关注公司动态，获取更多精准行业资讯</div>
                </div>
                <news></news>
                <div class="i_mbt partner-show">
                    <b>合作伙伴</b>
                    <div class="line">&nbsp;</div>
                    <div class="des"></div>
                </div>
                <partner></partner>
            </div>
        </div>
    </div>
</template>

<script>
import news from './news'
import intro from './intro.vue'
import companyCase from './companyCase'
import partner from './partner.vue'
export default {
    components: {
        news,
        intro,
        companyCase,
        partner,
    },
    data() {
        return {
            imgList: [
                require('../../../../assets/img/mainPage/banner1.png'),
                require('../../../../assets/img/mainPage/banner2.png'),
            ],
            height: 0,
        }
    },
    methods: {
        jumpProductDetail(id) {
            this.$router.push('/productDetail/' + id)
        },
    },
    created() {
        let deviceWidth = document.documentElement.clientWidth
        this.height = (deviceWidth * 931) / 1903 + 'px'
    },
}
</script>
<style scoped lang="less">
.i_ma {
    padding: 0 0 10px;
}

.i_ma .i_mam {
    width: 376px;
    float: left;
    margin-right: 20px;
    background: #fff;
    box-shadow: 0px 5px 30px 0px rgba(0, 0, 0, 0.06);
}

.i_ma .i_mar {
    margin-right: 0;
}

.i_ma .i_mar .tu {
    background: #ee8400;
}

.i_ma .i_mal .tu {
    background: #2395cb;
}

.i_ma .i_mac .tu {
    background: #3ed1a4;
}

.i_ma .i_mam .tu {
    width: 100%;
    height: 185px;
    position: relative;
    text-align: center;
}
.i_ma .i_mam .tu img {
    width: 40px;
    vertical-align: top;
    padding: 47px 0 11px;
}

.i_ma .i_mam p {
    font-size: 18px;
    color: #fff;
    text-align: center;
    margin-top: 3px;
}

.i_ma .i_mam .line {
    width: 90px;
    height: 1px;
    margin: 0px auto;
    margin-top: 7px;
}

.i_ma .i_mam i {
    display: block;
    width: 30px;
    height: 15px;
    position: absolute;
    left: 50% !important;
    transform: translate(-50%, 0);
    bottom: -15px;
}

.i_ma .i_mar .tu i {
    background: url(../../../../assets/img/mainPage/icon11.png) no-repeat;
}

.i_ma .i_mal .tu i {
    background: url(../../../../assets/img/mainPage/icon9.png) no-repeat;
}

.i_ma .i_mac .tu i {
    background: url(../../../../assets/img/mainPage/icon10.png) no-repeat;
}

.i_ma .i_mam .wen {
    width: 340px;
    margin: 0px auto;
    height: 310px;
    padding: 20px 0 10px;
}
.i_ma .i_mar .i_about .des {
    height: 84px;
}
.i_ma .i_about .des p {
    margin: 0px 3px;
    padding-top: 18px;
    text-align: left;
    font-size: 14px;
    color: #555;
    overflow: hidden;
    line-height: 24px;
}
.i_mbt {
    text-align: center;
    margin-top: 94px;
    position: relative;
    z-index: 9;
}

.i_mbt b {
    font-size: 30px;
    font-weight: bold;
    color: #333333;
    &.white-color {
        color: #ffffff;
    }
}

.i_mbt p {
    width: 100%;
    text-align: center;
    font-size: 14px;
    color: #555;
}

.i_mbt .line {
    width: 50px;
    height: 2px;
    background: #c2c2c2;
    margin: 0px auto;
    margin-top: 12px;
}
.i_mbt .des {
    margin-top: 14px;
    font-size: 16px;
    margin-bottom: 51px;
    color: #000000;
    &.white-color {
        color: #fff;
    }
}
.i_ma.clearfix .i_mam.i_mal .tu a p span {
    font-size: 12px;
    opacity: 0.46;
}

.i_ma.clearfix .i_mam.i_mac .tu a p span {
    font-size: 12px;
    opacity: 0.4;
}

.i_ma.clearfix .i_mam.i_mar .tu a p span {
    font-size: 12px;
    opacity: 0.4;
}
.i_about img {
    width: 340px;
    height: 170px;
    vertical-align: top;
}
.company-intro {
    height: 747px;
    background: url('../../../../assets/img/mainPage/home_bg1.png') no-repeat 0
        0;
    background-size: 100%;
}
.product-system {
    height: 833px;
    background: url('../../../../assets/img/mainPage/home_bg2.png') no-repeat 0
        0;
    background-size: 100%;
}
.digital-des p {
    line-height: 28px !important;
    padding: 0 18px 0 16px;
    &.first-p {
        padding-top: 10px !important;
    }
    & + p {
        margin-top: 11px !important;
    }
}
.case-show {
    height: 638px;
    background: url('../../../../assets/img/mainPage/home_bg3.png') no-repeat 0
        0;
    background-size: 100%;
    .i_mbt {
        margin-top: 100px;
    }
    .i_mbt .des {
        color: #999;
    }
}
.news-center {
    height: 1008px;
    background: url('../../../../assets/img/mainPage/home_bg4.png') no-repeat 0
        0;
    background-size: 100%;
    .i_mbt .des {
        color: #999;
        margin-bottom: 54px;
    }
}
.partner-show {
    margin-top: 89px;
}
</style>
